import React from "react";
import { graphql } from "gatsby";
import { getShortValueFromDictionary } from "../helpers";

import Layout from "../components/layout";

import Header from "../components/organisms/header";
import Footer from "../components/organisms/footer";
import Section from "../components/organisms/section";

import HeaderBrand from "../components/molecules/header-brand";
import FooterBrand from "../components/molecules/footer-brand";
import FooterNav from "../components/molecules/footer-nav";
import FooterCopy from "../components/molecules/footer-copy";
import NavBar from "../components/molecules/navbar";
import HeaderTitle from "../components/molecules/header-title";
import JobsTeaser from "../components/molecules/jobs-teaser";
import ImageSocial from "../components/molecules/image-social";
import FormContact from "../components/organisms/form-contact";
import FormWrapper from "../components/organisms/form-wrapper";
import DictionaryEntry from "../components/atoms/dictionary-entry";

import Seo from "../components/atoms/seo";

class Contact extends React.Component {
  render() {
    const dictionaryEdges = this.props.data.allContentfulDictionaryEntry.edges;
    return (
      <Layout location={this.props.location}>
        <Seo
          title={getShortValueFromDictionary(
            dictionaryEdges,
            "contact.seo-title",
            this.props.pageContext.language
          )}
          description={getShortValueFromDictionary(
            dictionaryEdges,
            "contact.seo-description",
            this.props.pageContext.language
          )}
        />
        <Header>
          <HeaderBrand />
          <NavBar
            context={this.props.pageContext.intl}
            language={this.props.pageContext.language}
          />
        </Header>
        <Section className="py-5">
          <HeaderTitle
            title={getShortValueFromDictionary(
              dictionaryEdges,
              "contact.header-title",
              this.props.pageContext.language
            )}
            highlightLastWord={true}
          />
          <div className="row">
            <div className="col-sm-6">
              <p>
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="contact.introduction"
                  language={this.props.pageContext.language}
                />
              </p>
            </div>
          </div>
        </Section>
        <Section className="py-sm-5 pb-sm-7 section-xs-transparent section-grey section-border-top section-border-bottom section-xs-border-0">
          <div className="row mb-5">
            <div className="col-sm-6 col-md-4">
              <h3 className="mb-4 h5">
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="contact.subtitle"
                  language={this.props.pageContext.language}
                />
              </h3>
              <address className="mb-5">
                <em>Blastic</em>
                <br />
                <a href="mailto:info@blastic.com">info@blastic.com</a>
                <br />
                <a href="tel:+32 3 808 50 81">+32 (0) 3 808 50 81</a>
                <br />
                <a href="tel:+31 20 323 2383">+31 (0) 20 323 2383</a>
              </address>
              <address className="mb-5">
                <em>Invoicing</em>
                <br />
                Veldkant 33A,
                <br />
                2550 Kontich
              </address>
            </div>
            <div className="col-sm-6 col-md-4">
              <h3 className="mb-4 h5">
                <DictionaryEntry
                  dictionaryEdges={dictionaryEdges}
                  dictionaryKey="contact.title-visit"
                  language={this.props.pageContext.language}
                />
              </h3>
              <address className="mb-5">
                <em>Antwerp</em>
                <br />
                Veldkant 4,
                <br />
                2550 Kontich
              </address>
              <address className="mb-5">
                <em>Ghent</em>
                <br />
                Gaston Crommenlaan 8/5,
                <br />
                9050 Ghent (Ledeberg)
              </address>
              <address className="mb-5">
                <em>Amsterdam</em>
                <br />
                Pedro de Medinalaan 73,
                <br />
                1086XP Amsterdam
              </address>
            </div>
            <div className="col-sm-12 col-md-4">
              <ImageSocial
                fluid={this.props.data.officesMap.childImageSharp.fluid}
                alt={getShortValueFromDictionary(
                  dictionaryEdges,
                  "contact.image-alt",
                  this.props.pageContext.language
                )}
                negateTop={true}
                negateRight={true}
              ></ImageSocial>
            </div>
          </div>
        </Section>
        <JobsTeaser image={this.props.data.jobsImage.childImageSharp.fluid} />
        <FormWrapper>
          <FormContact
            className="section-grey"
            dictionaryEdges={dictionaryEdges}
            language={this.props.pageContext.language}
          />
        </FormWrapper>
        <Footer>
          <FooterBrand />
          <FooterNav language={this.props.pageContext.language} />
          <FooterCopy />
        </Footer>
      </Layout>
    );
  }
}

export const query = graphql`
  query {
    officesMap: file(
      relativePath: { eq: "background/offices-map-with-nl.png" }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1000) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid
        }
      }
    }
    jobsImage: file(
      relativePath: {
        eq: "background/felipe-furtado-2zDXqgTzEFE-unsplash_2.png"
      }
    ) {
      childImageSharp {
        # Specify the image processing specifications right in the query.
        # Makes it trivial to update as your page's design changes.
        fluid(maxWidth: 1000) {
          # Choose either the fragment including a small base64ed image, a traced placeholder SVG, or one without.
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allContentfulDictionaryEntry(filter: { key: { regex: "/contact/i" } }) {
      edges {
        node {
          key
          shortValue
          richValue {
            raw
          }
          node_locale
        }
      }
    }
  }
`;

export default Contact;
